<slotcom-navigation-button
  type="close"
  (click)="closeModal()">
</slotcom-navigation-button>

<div
  id="shop-modal-background"
  class="m-shop-container"
  theming
  themingGroup="portal"
  themingAsset="shop-background">
  <div class="m-shop-header"></div>

  <slotcom-wallet
    [type]="'Coins'"
    [animate]="true"></slotcom-wallet>

  <div class="m-shop-content">
    @if (loading()) {
      <div class="loader-background">
        <div class="loader"></div>
      </div>
    }

    @if (inventory) {
      @if (!loading() && !loadingError()) {
        <slotcom-anchor-tab-display
          [sectionToGo]="sectionToGo()"
          [active]="!user.purchaseBlocked"
          [inventory]="inventory"
          [user]="user"></slotcom-anchor-tab-display>
      }
      <div class="content-container">
        @if (!loading() && loadingError()) {
          <div class="no-connection-img"></div>
        }
      </div>
    }
  </div>

  @if (loadingError() && !loading()) {
    <div class="m-shop-error">
      <div class="w-100 d-flex justify-content-center error-img"></div>
      <div
        class="w-100 d-flex justify-content-center error-message"
        [innerHTML]="'home.shop.noShop_1' | translate"></div>
      <div
        class="w-100 d-flex justify-content-center error-message error-message-pink"
        [innerHTML]="'home.shop.noShop_2' | translate"></div>
    </div>
  }

  <div class="m-shop-footer">
    <slotcom-golden-bomb></slotcom-golden-bomb>
    <slotcom-shop-offer></slotcom-shop-offer>
  </div>
  <slotcom-rich-club-icon [toolTipPosition]="'right'"></slotcom-rich-club-icon>
</div>
